/* eslint-disable no-undef */
export function loadProjectChart(
  myChart,
  value,
  text,
  seriesBg,
  lineColor,
  yColor,
  fontSizes
) {
  var data = [value, value, value];
  myChart.setOption({
    title: {
      text: (value * 100).toFixed(0) + "{a|%}",
      textStyle: {
        fontSize: fontSizes,
        fontFamily: "electronicFont",
        fontWeight: "normal",
        color: "#fff",
        rich: {
          a: {
            fontSize: fontSizes
          }
        }
      },
      x: "center",
      y: "30%"
    },
    graphic: [
      {
        type: "group",
        left: "center",
        top: "60%",
        children: [
          {
            type: "text",
            z: 100,
            left: "10",
            top: "middle",
            style: {
              fill: "#fff",
              text,
              fontSize: fontSizes
            }
          }
        ]
      }
    ],
    series: [
      {
        type: "liquidFill",
        radius: "85%",
        center: ["50%", "50%"],
        //  shape: 'roundRect',
        data: data,
        backgroundStyle: {
          color: {
            type: "linear",
            x: 1,
            y: 0,
            x2: 0.5,
            y2: 1,
            colorStops: seriesBg,
            globalCoord: false
          }
        },
        outline: {
          borderDistance: 0,
          itemStyle: {
            borderWidth: 4,
            borderColor: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: lineColor,
              globalCoord: false
            },
            shadowBlur: 10,
            shadowColor: "#000"
          }
        },
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: yColor,
          globalCoord: false
        },
        label: {
          normal: {
            formatter: ""
          }
        }
      }
    ]
  });
}
